import { render, staticRenderFns } from "./StaffStructure.vue?vue&type=template&id=866b0404&scoped=true"
import script from "./StaffStructure.vue?vue&type=script&lang=js"
export * from "./StaffStructure.vue?vue&type=script&lang=js"
import style0 from "./StaffStructure.vue?vue&type=style&index=0&id=866b0404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866b0404",
  null
  
)

export default component.exports